import React from 'react';
import styled from '@emotion/styled';

interface NoDataOverlayProps {
  message: string;
}

const NoDataOverlay = ({ message }: NoDataOverlayProps) => {
  return (
    <>
      <Overlay className="no-data" />
      <ChartMessage className="no-data">
        <h3>{message}</h3>
      </ChartMessage>
    </>
  );
};

export default NoDataOverlay;

const Overlay = styled.div`
  position: absolute;
  background: ${({ theme }) => theme.palette.background.default};
  opacity: 0.8;
  width: calc(100% - ${({ theme }) => theme.spacing(4)});
  height: 100%;
  z-index: 1;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
`;

const ChartMessage = styled.div`
  position: absolute;
  height: 20px;
  width: fit-content;
  z-index: 2;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;

  > h3 {
    opacity: 0.6;
    font-weight: ${({ theme }) => theme.typography.fontWeightNormal};
    font-style: italic;
  }
`;
